<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{$t('tlt.fm.thickenerPumpEdit')}}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/prd/thickenerPumpPara"><span>{{$t('tlt.fm.thickenerPump')}}</span></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/prd/thickenerPumpPara/edit"><span>{{$t('tlt.fm.thickenerPumpEdit')}}</span></router-link></li>
                </ul>
            </div>
            <div class="col-lg-4">
                <div class="float-lg-right">
                    <button class="btn btn-outline-secondary mr-1" type="button" v-on:click="MMFbackToList('thickenerPumpPara')"><i
                            class="fa fa-fw fa-lg fa-minus-circle"></i><span
                            class=text>{{$t('btn.basic.cancel')}}</span></button>
                    <button class="btn btn-primary" type="button" v-on:click="MMFSave('thickenerPumpPara')"><i
                            class="fa fa-fw fa-lg fa-save"></i><span class=text>{{$t('btn.basic.save')}}</span></button>
                </div>
            </div>
        </div>

        <section class="app-content">
            <form>
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.basic.date')}}：</label>
                                <mmf-datepicker v-model="day"></mmf-datepicker>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.basic.datetime')}}：</label>
                                <!-- <input class="form-control form-control-sm" type="time" v-model="time" name="time"> -->
                                <mes-time-picker v-model="time"></mes-time-picker>
                            </div>
                            <div class="form-group col-md-2" style="display: none">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>location id:</label>
                                <dimSearch  validate="required" name="locId"
                                            v-model="locId" :entity="locations" submitProp="id" bindProp="id" bindId="smeltingLocation">
                                </dimSearch>                                
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span
                                        class="lbl-obg">*</span>{{$t('lbl.location.area')}}:</label>
                                <dimSearch  validate="required" name="locName"
                                            v-model="locName" :entity="locations" submitProp="locName" bindProp="locName" bindId="smeltingLocation">
                                </dimSearch>                                
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.basic.furnaceName')}}：</label>
                                <select class="form-control" v-model="furnaceNumber" v-validate="'required'" name="furnaceNumber">
                                        <option value>{{$t("lbl.basic.select.one")}}</option>
                                        <option value="1">{{ $t("opt.furnaceNumber1") }}</option>
                                        <option value="2">{{ $t("opt.furnaceNumber2") }}</option>
                                        <option value="3">{{ $t("opt.furnaceNumber3") }}</option>
                                        <option value="4">{{ $t("opt.furnaceNumber4") }}</option>
                                        <option value="5">{{ $t("opt.furnaceNumber5") }}</option>
                                        <option value="6">{{ $t("opt.furnaceNumber6") }}</option>
                                </select>
                                <span v-show="errors.has('furnaceNumber')" class="lbl-obg">
                                    {{errors.first('furnaceNumber')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.thickenerScorpionPressure')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="thickenerScorpionPressure" name="thickenerScorpionPressure" v-validate="'required'">
                                <span v-show="errors.has('thickenerScorpionPressure')" class="lbl-obg">
                                    {{errors.first('thickenerScorpionPressure')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.pumpPressure')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="pumpPressure" name="pumpPressure" v-validate="'required'">
                                <span v-show="errors.has('pumpPressure')" class="lbl-obg">
                                    {{errors.first('pumpPressure')}}
                                </span>
                            </div>
                            <div class="form-group col-md-2">
                                <label class="control-label"><span class="lbl-obg">*</span>{{$t('lbl.fm.pumpLiquidLevel')}}：</label>
                                <input class="form-control form-control-sm" type="text" v-model="pumpLiquidLevel" name="pumpLiquidLevel" v-validate="'required'">
                                <span v-show="errors.has('pumpLiquidLeveFl')" class="lbl-obg">
                                    {{errors.first('pumpLiquidLevel')}}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </section>
    </div>
</template>

<script>
import {
        createHelpers
    } from 'vuex-map-fields';
    import {
        mapActions,mapState,
    } from "vuex";
    import {
        fields
    } from "@/model/prd/productionExecution/smelting/ThickenerPumpPara";
    import MmfDatepicker from '@/components/MmfDatepicker';
    import MesTimePicker from '@/components/MesTimePicker';
    import dimSearch from "@/components/MMFDimSearch";

    const {
        mapFields
    } = createHelpers({
        getterType: 'thickenerPumpPara/getField',
        mutationType: 'thickenerPumpPara/updateField',
    });
export default {
    data(){
        return {};
    },
    beforeMount() {
        this.$store.dispatch('thickenerPumpPara/loadLocations');
    },
    computed: {
            ...mapFields(fields),
            ...mapState({
                locations: state => state.thickenerPumpPara.locations,
            }),
        },
        methods: {
            ...mapActions("base", ["MMFbackToList", "MMFSave"]),            
        },
        components: {
            MmfDatepicker,
            MesTimePicker,
            dimSearch
        }
};
</script>